import { bodyTextColor } from './BodyTextStore';

export const updateBodyTextColor = (value) => bodyTextColor.update(oldValue => value);
